import React from "react";

import useWindowSize from "../hooks/useWindowSize";
import { IconName, Upgrade } from "../types";
import { getPriceFormatted } from "../util";
import Collapsable from "./Collapsable";
import EllipsisLoader from "./EllipsisLoader";
import Fancybox from "./Fancybox";
import Icon from "./Icon";
import InclusionDetail from "./InclusionDetail";
import MoreDetailsBtn from "./MoreDetailsBtn";
import Selectable from "./Selectable";

// @ts-ignore
const CollapsableImageContent = (props: {
  readonly?: boolean;
  layout: "inclusion" | "upgrade" | "turn_key" | "your_home" | "house_land";
  image: string;
  title: string;
  price: number;
  promo_price?: number;
  fixed_price?: boolean;
  address?: string; // Only used by house and land
  selected: boolean;
  selectableHidden?: boolean;
  insetTick?: boolean;
  onClick?: () => void;
  onClickMoreDetails?: () => void;
  innerHtml?: string;
  children?: JSX.Element;
  showDetailsAsAccordion?: boolean;
  details?: Upgrade | null;
  fullscreenButton?: boolean;
}) => {
  const windowSize = useWindowSize();

  const renderDetails = () => {
    if(props.details){
      return (
        <InclusionDetail
          hideBlurb={true}
          inclusion={props.details}
          hideImages={true}
        />
      );
    }else{
      return (<></>);
    }
  };

  return (
    <div
      className={`pyht-collapsable-image-content layout-${props.layout} ${
        props.readonly ? "readonly" : ""
      }`}
    >
      <Selectable
        selected={props.selected}
        hidden={props.selectableHidden}
        insetTick={props.insetTick}
      >
        <div className={"image-container"}>
          <EllipsisLoader />
          <img src={props.image} alt={""} />
          {props.fullscreenButton && (
            <Fancybox
              id={(Math.random() + 1).toString(36).substring(7)}
              href={props.image}
            >
              <div className={"fullscreen-btn"} role={"button"}>
                <Icon name={IconName.FULLSCREEN} />
              </div>
            </Fancybox>
          )}
        </div>
      </Selectable>
      <div className={`content-container ${props.showDetailsAsAccordion ? "scrollable" : ""}`}>
        <Collapsable
          disabled={props.readonly || windowSize.width >= 992}
          titleContent={
            <>
              <div className="flex">
                <div className="flex-left">
                  <h6 className="subtitle">{props.title.split(" ")[0]}</h6>
                  <h3 className={"title"}>{props.title.split(" ")[1]}</h3>
                  <p className={"price"}>
                    <span
                      className={`${
                        props.promo_price !== undefined ? "promo-applied" : ""
                      }`}
                    >
                      {getPriceFormatted(props.price)}
                    </span>
                    {props.promo_price !== undefined && (
                      <span className={"promo-price"}>
                        {getPriceFormatted(props.promo_price)}
                      </span>
                    )}
                  </p>
                </div>
                {!props.readonly && props.onClickMoreDetails && (
                  <MoreDetailsBtn
                    preventDefault={true}
                    title="See Details"
                    onClick={() =>
                      props.onClickMoreDetails && props.onClickMoreDetails()
                    }
                  />
                )}
              </div>
            </>
          }
          expandContent={
            <>
              {props.innerHtml ? (
                <div
                  className={"inner-html"}
                  dangerouslySetInnerHTML={{ __html: props.innerHtml }}
                />
              ) : props.children ? (
                props.children
              ) : null}
            </>
          }
        />
      </div>
      <div className="block-link"
        onClick={() => props.onClick && props.onClick()}
        role={"button"}
      ></div>
    </div>
  );
};

export default CollapsableImageContent;
